<div class="row mx-3">

  <div class="col-12 col-lg-3 p-2">
    <label for="laudoid">ID Laudo</label>
    <input [formControl]="form.controls.id" id="laudoid" type="number" class="form-control">
  </div>

  <div class="col-12 col-lg-3 p-2">
    <label for="placa">Placa</label>
    <input [formControl]="form.controls.placa" [textMask]="masks.placa" id="placa" class="form-control">
  </div>

  <div class="col-12 col-lg-3 p-2">
    <label for="tipolaudo">Tipo de laudo</label>
    <select [formControl]="form.controls.tipolaudo" id="tipolaudo" type="text" class="form-control">
      <option *ngFor="let o of listaTiposLaudos" [value]="o.id">{{o.nome}}</option>
    </select>
  </div>

  <div class="col-12 col-lg-3 p-2">
    <label for="cliente">Cliente</label>
    <select [formControl]="form.controls.cliente" id="cliente" type="text" class="form-control">
      <option *ngFor="let o of listaClientes" [value]="o.id">{{o.nomeFantasia}}</option>
    </select>
  </div>

  <div class="col-12 col-lg-3 p-2">
    <label for="unidade">Unidade</label>
    <select [formControl]="form.controls.unidade" id="unidade" type="text" class="form-control">
      <option *ngFor="let o of listaUnidadesClientes" [value]="o.id">{{o.nomeFantasia}}</option>
    </select>
  </div>

  <div class="col-12 col-lg-3 p-2">
    <app-date-interval [(inicio)]="params.filter.dataInicio" [(fim)]="params.filter.dataFim" (fimChange)="listaLaudos()"
      (inicioChange)="listaLaudos()"></app-date-interval>
  </div>

  <div class="col-12 col-lg-3 p-2">
    <label for="parecertecnico">Parecer Técnico</label>
    <select [formControl]="form.controls.parecertecnico" id="parecertecnico" type="text" class="form-control">
      <option *ngFor="let p of parecerTecnico" [value]="p.id">{{p.nome}}</option>
    </select>
  </div>

  <div class="w-100 px-3 pt-3">
    <div class="btn-group">
      <button [ngClass]="{'btn-theme': params.filter.status == ''}" (click)="setSituacaoLaudo('')"
        class="btn">Todos</button>
      <button [ngClass]="{'btn-theme': params.filter.status == '2'}" (click)="setSituacaoLaudo('2')"
        class="btn">Agendados</button>
      <button [ngClass]="{'btn-theme': params.filter.status == '0'}" (click)="setSituacaoLaudo('0')" class="btn">Em
        Andamento</button>
      <button [ngClass]="{'btn-theme': params.filter.status == '1'}" (click)="setSituacaoLaudo('1')"
        class="btn">Finalizados</button>
    </div>
  </div>
</div>

<div class="mx-2 my-4 mx-lg-4 card">
  <div class="table-responsive-lg">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Marca</th>
          <th>#</th>
          <th>Tipo Laudo</th>
          <th>Cliente</th>
          <th>Unidade</th>
          <th>Placa</th>
          <th>Criado em</th>
          <th>Atualizado em</th>
          <th>Parecer</th>
          <th>Status</th>
          <th>Integrações</th>
          <th class="text-right py-2">
            <button class="btn btn-sm btn-success" (click)="downloadExcel()"><i class="mdi mdi-download"></i> Download
              Excel</button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="listaResultado.length==0">
          <td class="text-center py-5 text-secondary w-500" colspan="10">
            Sem registros
          </td>
        </tr>
        <tr *ngFor="let r of listaResultado">
          <td>{{ r.fabricante }}</td>
          <td>{{ r.id }}</td>
          <td>{{ r.nometipolaudo }}</td>
          <td>{{ r.nomecliente ? r.nomecliente : 'PARTICULAR'}}</td>
          <td>{{ r.nomeunidade }}</td>
          <td>{{ r.placa }}</td>
          <td>{{ r.datacriacao | date: 'dd/MM/yyyy' }}</td>
          <td>{{ r.dataultimaatualizacao | date: 'dd/MM/yyyy' }}</td>
          <td>
            {{r?.parecertecnico == 1 ? 'APROVADO' : ''}}
            {{r?.parecertecnico == 2 ? 'APROVADO COM RESTRIÇÕES' : ''}}
            {{r?.parecertecnico == 3 ? 'APROVADO COM APONTAMENTO' : ''}}
            {{r?.parecertecnico == 4 ? 'REPROVADO' : ''}}
            {{r?.parecertecnico == 5 ? 'PENDENTE' : ''}}
            {{r?.parecertecnico == undefined ? 'PENDENTE' : ''}}
          </td>
          <td>
            {{r.status == 0 ? 'CRIADO' : '' }}
            {{r.status == 1 ? 'FINALIZADO' :'' }}
            {{r.status == 2 ? 'AGENDADO' : '' }}
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-end" *ngIf="r.statusintegracao!=null">
              <button class="btn btn-sm btn-outline-success btn-icon mr-1"
                (click)="openSyncSuccess(modalSyncSuccess, r)" *ngIf="r.statusintegracao=='OK'">
                <i class="mdi mdi-check"></i>
              </button>
              <button class="btn btn-sm btn-outline-warning btn-icon mr-1" (click)="openSyncError(modalSyncError, r)"
                *ngIf="r.statusintegracao=='NAOENCONTRADO'">
                <i class="mdi mdi-sync-alert"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger btn-icon mr-1" (click)="openSyncError(modalSyncError, r)"
                *ngIf="r.statusintegracao=='ERRO'">
                <i class="mdi mdi-sync-alert"></i>
              </button>
            </div>
          </td>
          <td class="py-1">
            <div class="d-flex align-items-center justify-content-center">
              <span data-toggle="tooltip" data-placement="bottom" title="Editar Laudo">
                <a [routerLink]="['/laudo','editar', r.tokenlaudo, 0]" rel="noopener noreferrer" target="_blank"
                  class="btn btn-sm btn-primary btn-icon mr-1">
                  <i class="mdi mdi-pencil"></i>
                </a>
              </span>
              <span data-toggle="tooltip" data-placement="bottom" title="Visualizar Laudo">
                <a [routerLink]="['/laudo','visualizar', r.tokenlaudo]" rel="noopener noreferrer" target="_blank"
                  class="btn btn-sm btn-info btn-icon">
                  <i class="mdi mdi-eye"></i>
                </a>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="card-footer bg-white row justify-content-between">
    <div class="pb-2 pb-sm-0">
      <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total"
        [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="pb-2 pb-sm-0">
      <div class="btn-group" role="group">
        <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}"
          type="button" class="btn btn-outline-primary">10</button>
        <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}"
          type="button" class="btn btn-outline-primary">25</button>
        <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}"
          type="button" class="btn btn-outline-primary">50</button>
        <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}"
          type="button" class="btn btn-outline-primary">100</button>
      </div>
    </div>
  </div>
</div>